import { getRegistrantAccountOptions } from "@/hera-api/client/@tanstack/react-query.gen";
import { useAuthQuerySetup } from "@/hooks/use-auth-query-setup";
import { useQuery } from "@tanstack/react-query";

export function useRegistrantOrgPermissions() {
  const { isAuthSetupComplete } = useAuthQuerySetup();
  const onOmtAmsPortal =
    typeof window !== "undefined" &&
    window.location.pathname.startsWith("/omt-ams");
  const { data: account } = useQuery({
    ...getRegistrantAccountOptions(),
    enabled: isAuthSetupComplete && !onOmtAmsPortal,
  });

  return {
    isAdmin: Boolean(account?.is_admin),
    canMakePayments: Boolean(account?.can_make_payments),
    account,
  };
}
